<template>
  <div class="border-b-md border-solid border-border-secondary">
    <NuxtLink
      :to="link.url"
      external
      class="no-underline text-text-primary w-full block py-16 md:py-24 hover:bg-surface-action-hover"
      :aria-label="link.aria"
      @click="link.url && pushSubMenyClickEvent(link.url)"
    >
      <span class="link-focus">
        {{ link.label }}
      </span>
    </NuxtLink>
  </div>
</template>

<script lang="ts" setup>
import type { MenuModalLink } from './ModalLinks.vue';
const { pushSubMenyClickEvent } = useGoogleAnalyticsEvents();

defineProps<{
  link: MenuModalLink;
  isOpen: boolean | false;
}>();
</script>

<style lang="scss" scoped>
a:focus {
  outline: none;
}
a:focus > .link-focus {
  @apply border-md border-solid border-border-highlight rounded-xs;
}
.router-link-active {
  color: $green-700;
  &::after {
    content: '';
    display: inline-block;
    height: 0.6rem;
    width: 0.6rem;
    border-radius: 50%;
    margin: 2px 6px;
    vertical-align: middle;
    background-color: $green-700;
  }
}
</style>
